<template>
  <div class="content-block">
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          Vytvořit požadavek na reset hesla
        </h5>
        <div class="section-title-controls">
          <ActiveButton class="asd-btn-confirm"
                        :click="create"
          >
            <i class="fas fa-envelope"></i>
          </ActiveButton>
        </div>
      </div>
      <div class="asd-form">
        <div>
          <label>Uživatelské jméno (email)</label>
          <input v-model="username"
                 type="text"
                 class="asd-input"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from 'CORE/bus'
import ActiveButton from 'CORE/components/form/active-button'

export default {
    name: 'RequestPasswordResetForm',
    components: {
        ActiveButton,
    },
    props: {
        token: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data() {
        return {
            username: '',
        }
    },
    computed: {
    },
    mounted() {
        if (this.token !== null) {
            this.tokenInput = this.token
        }
    },
    methods: {
        async create() {
            try {
                await this.$store.dispatch('requestResetPassword', {
                    username: this.username,
                })
                EventBus.$emit('FLASH_OK', { message: `Požadavek na změnu vytvořen. Vyčkejte na email.` })
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
    },
}
</script>
